<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Cadastro de Fornecedores</h2>
        <v-spacer></v-spacer>
        <v-btn @click="onNewButtonClick()" small color="primary">Novo</v-btn>
      </v-card-title>
      <v-card-text>
        <e-data-table
          :headers="headers"
          :items="fornecedores"
          :total="total"
          @refresh="getAll"
          @edit="editItem"
          @delete="deleteItem"
        ></e-data-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>
import { showError, showConfirm, retPermissao } from '@/utils'
import fornecedorService from '@/services/fornecedor'
import EDataTable from '@/components/EDataTable'

export default {
  name: 'fornecedores',
  components: {
    EDataTable
  },
  data () {
    return {
      profissional: {},
      fornecedores: [],
      total: 0,
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Fornecedor', value: 'nome', sortable: false },
        { text: 'Cidade', value: 'localidade', sortable: false },
        { text: 'Estado', value: 'uf', sortable: false }],
      dialog: false,
      valid: true,
      rules: {
        nome: [v => !!v || 'Campo Requerido']
      },
      buttonSaveLoadingVisible: false
    }
  },
  methods: {
    async getAll (page, search) {
      try {
        let result = search === '' ? await fornecedorService.getAll(page) : await fornecedorService.getByNome(search, page)
        this.total = result._meta.total_items
        this.fornecedores = result.data
      } catch (error) {
        showError(error)
      }
    },
    editItem (item) {
      var ret = retPermissao('Fornecedores', 'alterar')
      if (ret === true) {
        this.$router.push(`/fornecedores/editar/${item.id}`)
      }
    },
    async deleteItem (item) {
      var ret = retPermissao('Fornecedores', 'excluir')
      if (ret === true) {
        showConfirm(`Tem certeza que deseja remover fornecedor ${item.nome} ?`, async result => {
          if (result) {
            try {
              this.loading = true
              await fornecedorService.delete(item.id)
              this.getAll(1, '')
            } catch (error) {
              showError(error)
            } finally {
              this.loading = false
            }
          }
        })
      }
    },
    onNewButtonClick () {
      var ret = retPermissao('Fornecedores', 'incluir')
      if (ret === true) {
        this.$router.push(`/fornecedores/criar`)
      }
    }
  }
}
</script>
<style scoped>
.flex{
    height: 60px;
  }
</style>
